import React from "react";
import NavProfile from "./NavProfile";
import NavNotificationBell from "./NavNotificationBell";

const NavPanel = () => (
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <NavNotificationBell />
    <NavProfile />
  </div>
);

export default NavPanel;
